window.KeyOptions.on("price-updated", ({ totalPriceCents }) => {
	const basePrice = window.KeyOptions.shopify.productPrice;

	setTimeout(() => {
		const totalsContainer = document.querySelector(".key_option_set + div");
		if (totalsContainer) {
			const spans = totalsContainer.querySelectorAll("span");

			if (spans.length >= 2) {
				spans[spans.length - 2].textContent = "Total:";

				spans[spans.length - 1].textContent = (parseFloat(totalPriceCents / 100) + basePrice).toLocaleString(Shopify.locale + '-' + Shopify.country, {
					style: 'currency',
					currency: Shopify.currency.active
				});
			}
		}
	}, 0);
});